<template>
  <div>
    <div id="app">
      <div id="print"></div>
      <div id="web">
        <router-view></router-view>
        <CookiesBanner />
        <Loading v-if="isAppLoading"></Loading>
        <LoadingEdc ref="loadingEdc" v-if="isEdcProcessing" :timeoutMinutes="edcTimeoutMinutes" />

        <Dialog ref="Alert"></Dialog>
        <TransferProgressToast />
      </div>
    </div>
  </div>
</template>

<script>
import CookiesBanner from "./components/form/CookiesBanner.vue";
import Dialog from "@/components/modal/Dialog";
import TransferProgressToast from "@/components/TransferProgressToast.vue";
import { installFileDropGuard } from "@/utils/fileDropGuard";
import { eventBus } from "@/main";
import Loading from "./components/Loading.vue";
import LoadingEdc from "@/components/LoadingEdc.vue";
import errorService from "@/services/ErrorService";

export default {
  name: "App",
  components: {
    CookiesBanner,
    Dialog,
    Loading,
    LoadingEdc,
    TransferProgressToast,
  },
  created() {
    // Set up error service reference to this app instance for UI interactions
    errorService.setAppReference(this);
    
    // Maintain backward compatibility for existing eventBus error emissions
    // This will be phased out as stores are refactored
    eventBus.$on("apiError", err => {
      errorService.handleError(err, { source: 'eventBus_legacy' });
    });
    eventBus.$on(
      "alertToast",
      ({ message, variant = "danger", noAutoHide = false }) => {
        this.$refs.Alert.showToast(variant, message, noAutoHide);
      }
    );
    eventBus.$on(
      "alertSwal",
      ({ title, message, icon = "info", callback = () => {} }) => {
        this.$refs.Alert.showAlertInfo(title, message, icon).then(callback);
      }
    );
    eventBus.$on(
      "confirmSwal",
      ({ title, message, icon = "warning", callback = () => {} }) => {
        this.$refs.Alert.showAlertConfirm(title, message, icon).then(callback);
      }
    );
    eventBus.$on("appLoadingStatus", e => {
      this.isAppLoading = e;
    });
    eventBus.$on("edcProcessingStatus", e => {
      this.isEdcProcessing = e;
    });
    eventBus.$on("setEdcTimeout", timeoutMinutes => {
      this.edcTimeoutMinutes = timeoutMinutes;
    });
    eventBus.$on("showSpinnerToast", () => {
      this.$refs.Alert.showToastWithSpinner();
    });
    eventBus.$on("hideSpinnerToast", () => {
      this.$refs.Alert.hideToast();
    });
  },
  mounted() {
    this.removeFileDropGuard = installFileDropGuard();

    // Hide loading screen once app is mounted
    const loadingScreen = document.getElementById("app-loading");
    if (loadingScreen) {
      loadingScreen.classList.add("app-loading-hidden");
      // Remove from DOM after transition
      setTimeout(() => {
        loadingScreen.remove();
      }, 300);
    }
  },
  beforeDestroy() {
    if (this.removeFileDropGuard) this.removeFileDropGuard();
  },
  data() {
    return {
      isAppLoading: false,
      isEdcProcessing: false,
      edcTimeoutMinutes: 5, // Default 5 minutes
    };
  },
};
</script>